import React from 'react';

import {
  FieldError as AriaFieldError,
  FieldErrorProps as AriaFieldErrorProps,
} from 'react-aria-components';

import styles from './ErrorMessage.module.scss';

type ErrorMessageProps = AriaFieldErrorProps & {
  children: React.ReactNode;
  isCompact?: boolean;
};

/**
 * An error message. Must be rendered inside an invalid form element component.
 */
export const ErrorMessage = ({
  children,
  isCompact,
  ...props
}: ErrorMessageProps) => {
  return (
    <AriaFieldError
      {...props}
      className={styles.errorMessage}
      data-compact={isCompact}
      data-zds
    >
      {children}
    </AriaFieldError>
  );
};
